import { Box, BoxProps, ButtonNew, ColorOptions, ModBox, Spacer, Text } from '@jfs/ui-new'
import { useEffect } from 'react'
import { FlatList } from 'react-native-gesture-handler'
import { renderCardIcon } from '../../../comps/CreditCard/CardType'
import { CVVInput } from '../../../comps/CreditCard/CVVInput'
import { convertHexToRGBA, getCardLogo, getCardVendor } from '../../../utils'

interface SavedCardEmiListProps {
  cardList: any
  onSelectEmiPlanPress: any
  theme: any
  isLoading: any
  buttonText: any
  cvv: any
  onCvvChange: any
  selectedCardIndex: any
  setSelectedCardIndex: any
}

export const SavedCardEmiList = ({
  cardList,
  onSelectEmiPlanPress,
  theme,
  isLoading,
  buttonText,
  cvv,
  onCvvChange,
  selectedCardIndex,
  setSelectedCardIndex,
}: SavedCardEmiListProps) => {
  const renderFLItem = ({ item, index }: any) => {
    return (
      <SavedCardEmi
        item={item}
        onSelectEmiPlanPress={onSelectEmiPlanPress}
        theme={theme}
        isLoading={isLoading}
        buttonText={buttonText}
        cvv={cvv}
        onCvvChange={onCvvChange}
        index={index}
        isSelected={selectedCardIndex === index}
        setSelectedCardIndex={() => setSelectedCardIndex(selectedCardIndex === index ? -1 : index)}
      />
    )
  }
  return (
    <FlatList
      data={cardList ?? []}
      renderItem={renderFLItem}
      style={{ borderTopWidth: 1, borderTopColor: convertHexToRGBA(theme.bodyTextColor, 10) as ColorOptions }}
    />
  )
}

const SavedCardEmi = ({
  item,
  isSelected,
  setSelectedCardIndex,
  onSelectEmiPlanPress,
  theme,
  isLoading,
  buttonText,
  cvv,
  onCvvChange,
  index,
}: any) => {
  const types: any = {
    CREDITCARD: 'Credit Card',
    DEBITCARD: 'Debit Card',
  }
  const maxCvvLength = getCardVendor(item.scheme) === 'amex' ? 4 : 3
  useEffect(() => {
    if (!isSelected) {
      onCvvChange('')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSelected])
  return (
    <Box
      {...styles.itemContainer}
      backgroundColor={isSelected ? (convertHexToRGBA(theme.brandColor, 10) as ColorOptions) : 'TRANSPARENT'}
      onPress={setSelectedCardIndex}
      testID={'select-card-' + index}
      borderBottomColor={convertHexToRGBA(theme.bodyTextColor, 10) as ColorOptions}>
      {renderCardIcon(getCardVendor(parseInt(item.scheme, 10)), getCardLogo(parseInt(item.scheme, 10)))}
      <Box {...styles.rightContainer}>
        <Box flexDirection="row">
          <Box flexDirection={'column'} marginRight={16} flex={1}>
            <Text fontSize={14} fontFamily="jioType-medium" color={theme.bodyTextColor as ColorOptions}>
              {types[item?.type]}
            </Text>
            <Spacer direction="vertical" size={8} />
            <Text
              fontSize={14}
              fontFamily="jioType-medium"
              color={convertHexToRGBA(theme.bodyTextColor, 50) as ColorOptions}>
              {item?.number}
            </Text>
          </Box>
          <ModBox
            width={70}
            show={isSelected && !item?.isCvvLess}
            onPress={() => { }}
            underlayColor="TRANSPARENT"
            marginTop={-4}>
            <CVVInput
              maxCvvLength={maxCvvLength}
              isValidCVV={() => { }}
              cvv={cvv}
              setCvv={onCvvChange}
              theme={theme}
              autoFocus={true}
            />
          </ModBox>
        </Box>
        {item?.isCvvLess && <Spacer direction="vertical" size={20} />}
        {isSelected && (
          <ButtonNew
            onPress={() => onSelectEmiPlanPress(item)}
            type="secondaryFullWidth"
            title={isSelected ? buttonText : 'Select a EMI Plan'}
            height={40}
            testID={'select-emi-plan-' + index}
            color="TRANSPARENT"
            isLoading={isSelected && isLoading}
            titleColor={theme.brandColor as ColorOptions}
            borderColor={theme.brandColor as ColorOptions}
            loadingColor={theme.brandColor as ColorOptions}
          />
        )}
      </Box>
    </Box>
  )
}

const styles = {
  itemContainer: {
    p: 24,
    flexDirection: 'row',
    underlayColor: 'TRANSPARENT',
    borderBottomWidth: 1,
  } as BoxProps,
  rightContainer: {
    flexDirection: 'column',
    flex: 1,
    marginLeft: 16,
  } as BoxProps,
  rightContainerw: {} as BoxProps,
  rightContainewwdr: {} as BoxProps,
}
